import { BreadcrumbHelper, BreadcrumbNavigation as breadcrumbnavigation, IBreadcrumbLevel } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import Constants from '../../constants';
import ContentConstants from '../../contentConstants';
import { IApplicationState } from '../../store';
import { NavigationActions } from '../../store/NavigationActions';

/*
	Note: the limitations of this container are as follows
		  1) there is no smart router-reader... all routes are explicit in this file for 
			   the area in which we're using breadcrumbs
				** It will not generate a breadcrumb level when it cannot parse a piece of the route
		  2) must explicitly declare the page title, route and subroute for every "part" of a location's pathname
				** the navigation action creator is called by extracting the surveyId from the route params

	Before this can be broadly used, it seems that we need a friendly way of determining routes so this giant switch
	statement is unnecessary.

	TODO: move GetLevelsForRoute out of this file and into something that can parse all the routes for a service
*/

/* 
Because we are now using the breadcrumbs component from Common UI, the CSS override is in place until proper
implementation has been done for breadcrumbs, router in a layout 
*/
const BreadcrumbNavigation = styled(breadcrumbnavigation)`
	&.tws-breadcrumbs {
		top: 15px;
	}
`;

export interface IBreadcrumbContainerProps {
	match: any;
	location: any;
}

const getLevelsForRoute = (location: any): IBreadcrumbLevel[] => {
	const parts = location.pathname.split('/');
	const levels: IBreadcrumbLevel[] = [];

	let sequence = 1;
	parts.forEach((part: string) => {
		switch (part) {
			case 'survey-admin':
				levels.push(
					BreadcrumbHelper.createLevel(ContentConstants.SURVEY_ADMIN_HEADER_CONTROL_PANEL, sequence, Constants.ROUTE_SURVEY_ADMIN),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_EDIT_SURVEY:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_ACTION_EDIT_SURVEY,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_EDIT_SURVEY,
					),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_BENCHMARKS:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_ACTION_ADD_SUBTRACT_BENCHMARKS,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_BENCHMARKS,
					),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_INVITE_EMAIL:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_ACTION_INVITE_EMAIL,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_INVITE_EMAIL,
					),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_OPEN_CLOSE:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_OPEN_CLOSE,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_OPEN_CLOSE,
					),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_PARTICIPANTS:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_ACTION_DISTRIBUTION_LIST,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_PARTICIPANTS,
					),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_RESET_REOPEN_RESEND:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_ACTION_RESET_REOPEN_RESEND,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_RESET_REOPEN_RESEND,
					),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_PARTICIPATION_MONITOR:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_ACTION_PARTICIPATION_MONITOR,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_PARTICIPATION_MONITOR,
					),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_REMINDER_EMAIL:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_ACTION_REMINDER_EMAILS,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_REMINDER_EMAIL,
					),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_REPORTING_ACCESS:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_ACTION_REPORTING_USERS,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_REPORTING_ACCESS,
					),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_SURVEY_OVERVIEW:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_ACTION_SURVEY_OVERVIEW,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_SURVEY_OVERVIEW,
					),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_MANAGE_DIMENSIONS:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_ACTION_MANAGE_DIMENSION_LIST,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_MANAGE_DIMENSIONS,
					),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_MANAGE_DIMENSIONS_ADD:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_ACTION_MANAGE_DIMENSION_CREATE,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_MANAGE_DIMENSIONS_ADD,
					),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_TREND_TO:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_ACTION_TREND_TO,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_TREND_TO,
					),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_HIERARCHY_VIEW:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_ACTION_HIERARCHY_VIEW,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_HIERARCHY_VIEW,
					),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_ANONYMITY_THRESHOLD:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_ACTION_ANONYMITY_THRESHOLD,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_ANONYMITY_THRESHOLD,
					),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_REPORTING_PROFILES:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_ACTION_REPORTING_PROFILES,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_REPORTING_PROFILES,
					),
				);
				sequence++;
				break;
			case Constants.SUBROUTE_SURVEY_ADMIN_AUDIENCE:
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_AUDIENCE_HEADER_CONTROL_PANEL,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_AUDIENCE,
					),
				);
				sequence++;
				break;
		}

		if (parseInt(part, 0) > 0) {
			if (
				levels.findIndex((l) => {
					return l.subroute === Constants.SUBROUTE_SURVEY_ADMIN_MANAGE_DIMENSIONS;
				}) > -1
			) {
				levels.push(
					BreadcrumbHelper.createLevel(
						ContentConstants.SURVEY_ADMIN_ACTION_MANAGE_DIMENSION_EDIT,
						sequence,
						Constants.ROUTE_SURVEY_ADMIN,
						Constants.SUBROUTE_SURVEY_ADMIN_MANAGE_DIMENSIONS,
					),
				);
				sequence++;
			}
		}

		if (parseInt(part, 0) > 0) {
			const audienceLevelIndex = levels.findIndex((l) => {
				return l.subroute === Constants.SUBROUTE_SURVEY_ADMIN_AUDIENCE;
			});
			if (audienceLevelIndex > -1) {
				levels[audienceLevelIndex].subroute = levels[audienceLevelIndex].subroute + `/${part}`;
			}
		}
	});

	return levels;
};

export const mapStateToProps = (state: IApplicationState, props: IBreadcrumbContainerProps) => {
	return {
		levels: getLevelsForRoute(props.location),
	};
};

export const mapDispatchToProps = (dispatch: any, props: IBreadcrumbContainerProps) => ({
	navigation: (route: string, subroute?: string) => dispatch(NavigationActions.Navigate(route, props.match.params.surveyId, subroute)),
});

export const BreadcrumbNavigationConnect: React.ComponentType<IBreadcrumbContainerProps> = connect(
	mapStateToProps,
	mapDispatchToProps,
)(BreadcrumbNavigation);

export class BreadcrumbContainer extends React.PureComponent<RouteComponentProps<{}>> {
	public render() {
		return <BreadcrumbNavigationConnect {...this.props} />;
	}
}
